import script from "./icon-two-tones-gallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-gallery.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-gallery.vue?vue&type=style&index=0&id=02809ef4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02809ef4"]])

export default __exports__